import Vue from 'vue';
import router from '@/router';
import { CLASSTING_FULL_AUTH_URL } from '@/config';
import { setToken, removeToken, setCountryCode, removeCountryCode } from '@/plugins/http';

import types from './mutation-types';

function subscribe(store) {
  store.subscribe((mutation, { Auth }) => {
    switch (mutation.type) {

      case types.SET_TOKEN: {
        setToken(Auth.token);
        break;
      }

      case types.SET_USER: {
        Vue.$ga.set('userId', Auth.user.id);
        Vue.$ga.set('dimension1', Auth.user.role);
        Vue.$ga.set('dimension2', Auth.user.grade);
        Vue.$ga.set('dimension3', Auth.user.school_id);
        Vue.$ga.set('dimension4', Auth.user.zipcode);

        setCountryCode(Auth.user.country_code);

        break;
      }

      case types.SET_PROPERTY: {
        break;
      }

      case types.SIGN_OUT: {
        removeToken();
        removeCountryCode();

        if (router.currentRoute.meta.requiresAuth) {
          window.location.href = CLASSTING_FULL_AUTH_URL;
        }

        break;
      }

      default: {
        break;
      }

    }
  });
}

export default (store) => {
  subscribe(store);
};



// WEBPACK FOOTER //
// ./src/app/auth/store/plugin.js